<template>
    <div
        class="relative w-full py-2 px-5 flex items-center justify-between text-slate-800"
        :class="{
            'opacity-60 cursor-not-allowed': props.disabled,
            'border-x-0 border-t-0 last:border-b-0 border-b border-slate-200 border-solid': props.borderBottom,
        }"
    >
        <div
            v-if="props.selectedIndicator && props.selected"
            class="block w-1 inset-y-3 bg-sky-300 rounded-full absolute inset-s-1.5 pointer-events-none"
        ></div>

        <div class="text-sm flex items-start gap-4">
            <div
                :class="{
                    'font-bold': props.contact.first_name || props.contact.last_name || props.contact.invalid,
                }"
            >
                {{ displayContactName(props.contact) }}
            </div>
            <div v-if="props.contact.first_name || props.contact.last_name">
                {{ formatPhoneNumber(props.contact.phone) }}
            </div>
            <div v-if="props.contact.invalid">
                {{ props.contact.invalid }}
            </div>
        </div>

        <div class="text-right">
            <vx-button
                @click="emit('toggle')"
                type="button"
                color="muted"
                size="xs"
                :outline="!props.selected"
                :disabled="props.disabled"
            >
                {{ props.selected ? 'Remove' : 'Add' }}
                <font-awesome-icon
                    widthAuto
                    class="text-xs ml-1"
                    :icon="props.selected ? faCircleMinus : faCirclePlus"
                ></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import { displayContactName, formatPhoneNumber } from '~/components/filters';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
    selected: {
        type: Boolean,
        required: false,
    },
    selectedIndicator: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    borderBottom: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['toggle']);
</script>
